import {
  GET_LOANS,
  GET_LOANS_SUCCESS,
  GET_LOANS_FAILURE,
  GET_60_DAY_LOANS,
  GET_60_DAY_LOANS_SUCCESS,
  GET_60_DAY_LOANS_FAILURE,
  GET_CASH_FLOW_LOANS,
  GET_CASH_FLOW_LOANS_SUCCESS,
  GET_CASH_FLOW_LOANS_FAILURE,
  GET_LOAN,
  GET_LOAN_SUCCESS,
  GET_LOAN_FAILURE,
  GET_LOAN_MATURITY_REPORT,
  GET_LOAN_MATURITY_REPORT_SUCCESS,
  GET_LOAN_MATURITY_REPORT_FAILURE,
} from './constants';

// Get Loans
export const getLoans = () => ({
  type: GET_LOANS,
  payload: { },
});

export const getLoansSuccess = (loans) => ({
  type: GET_LOANS_SUCCESS,
  payload: loans,
});

export const getLoansFailure = (error) => ({
  type: GET_LOANS_FAILURE,
  payload: { message: error },
});

// Get 60-Day Loans
export const get60DayLoans = () => ({
  type: GET_60_DAY_LOANS,
  payload: { },
});

export const get60DayLoansSuccess = (loans) => ({
  type: GET_60_DAY_LOANS_SUCCESS,
  payload: loans,
});

export const get60DayLoansFailure = (error) => ({
  type: GET_60_DAY_LOANS_FAILURE,
  payload: { message: error },
});

//Get Cash Flow Report
export const getCashFlowLoans = () => ({
  type: GET_CASH_FLOW_LOANS,
  payload: { }
})

export const getCashFlowLoansSuccess = (loans) => ({
  type: GET_CASH_FLOW_LOANS_SUCCESS,
  payload: loans
})

export const getCashFlowLoansFailure = (error) => ({
  type: GET_CASH_FLOW_LOANS_FAILURE,
  payload: { message: error },
})

// Get Loan
export const getLoan = (loanId) => ({
  type: GET_LOAN,
  payload: { loanId },
});

export const getLoanSuccess = (loan) => ({
  type: GET_LOAN_SUCCESS,
  payload: loan,
});

export const getLoanFailure = (error) => ({
  type: GET_LOAN_FAILURE,
  payload: { message: error },
});

export const getLoanMaturityReport = () => ({
  type: GET_LOAN_MATURITY_REPORT,
  payload: { },
});

export const getLoanMaturityReportSuccess = (report) => ({
  type: GET_LOAN_MATURITY_REPORT_SUCCESS,
  payload: report,
});

export const getLoanMaturityReportFailure = (error) => ({
  type: GET_LOAN_MATURITY_REPORT_FAILURE,
  payload: { message: error },
});